import React from 'react';
import ServicePageTemplate from './ServicePageTemplate';
import { crmConfig } from './servicePageConfigs';

const ServiceDetails = () => <ServicePageTemplate {...crmConfig} />;

export default ServiceDetails;
